import { render, staticRenderFns } from "./AdviseCourse.vue?vue&type=template&id=3ae1a84e&scoped=true"
import script from "./AdviseCourse.vue?vue&type=script&lang=js"
export * from "./AdviseCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1a84e",
  null
  
)

export default component.exports